import React from 'react';
import { Button } from './ui/button';
import { Download, ChevronDown } from 'lucide-react';

export const Hero = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[100svh] flex flex-col justify-between bg-[#05050A] overflow-hidden pt-20 pb-6">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-purple-primary/20 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-green-primary/10 rounded-full blur-[100px]"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center px-5 sm:px-6 lg:px-8">
        <div className="max-w-lg mx-auto lg:max-w-4xl text-center lg:text-left">
          {/* Logo - Smaller on mobile */}
          <div className="mb-6 animate-fade-in flex justify-center lg:justify-start">
            <img 
              src="https://customer-assets.emergentagent.com/job_gameodys-hub/artifacts/fbqbhqqa_WhatsApp_Image_2025-09-08_at_21.11.32-removebg-preview.png" 
              alt="Gameodys Logo" 
              className="h-24 w-24 sm:h-32 sm:w-32 object-contain brightness-0 invert"
            />
          </div>

          {/* Overline */}
          <p className="overline mb-3 animate-fade-in">Truco Competitivo</p>
          
          {/* Main Title - Mobile optimized */}
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black font-archive text-white leading-[1.1] mb-4 animate-slide-up">
            O maior Truco<br />
            <span className="text-green-primary">competitivo</span> do Brasil.
          </h1>
          
          {/* Subtitle - Compact for mobile */}
          <div className="space-y-1.5 mb-6 animate-slide-up delay-200">
            <p className="text-base sm:text-lg text-gray-300 font-hero">
              Partidas rápidas • Ranking • Torneios
            </p>
            <p className="text-sm sm:text-base text-green-primary font-hero font-medium">
              Jogue grátis ou em desafios com recompensas
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start animate-slide-up delay-400">
            <Button 
              data-testid="hero-cta-download"
              className="btn-neon w-full sm:w-auto px-8 py-6 text-base sm:text-lg rounded-xl"
            >
              <Download className="mr-2 h-5 w-5" />
              Baixar Grátis
            </Button>
            
            <Button 
              data-testid="hero-cta-how"
              variant="outline"
              onClick={() => scrollToSection('como-jogar')}
              className="w-full sm:w-auto px-8 py-6 text-base sm:text-lg rounded-xl border-purple-primary/50 text-white hover:bg-purple-primary/20 hover:border-purple-primary"
            >
              Como Funciona
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="relative z-10 flex justify-center animate-bounce">
        <button 
          onClick={() => scrollToSection('como-jogar')}
          className="p-2 text-gray-400 hover:text-green-primary transition-colors"
          aria-label="Scroll para baixo"
        >
          <ChevronDown size={28} />
        </button>
      </div>
    </section>
  );
};
